const intialState = {
    plants: [],
    plantName: "all",
    plantData: [],
    areaId: {}
  };
  
  export const plantsReducer = (state = intialState, { type, payload }) => {
    switch (type) {
      case "LIST_PLANTS":
        return { ...state, plants: payload };
      case "FILTER_PLANT_NAME":
        return { ...state, plantName: payload };
      case "PLANT_DATA":
        return { ...state, plantData: payload };
      case "AREA_DETAILS":
        return { ...state, plantData: payload };
      default:
        return state;
    }
  };